module.exports = __webpack_public_path__ + "static/media/consultores2.844bea0c.webp";